import styled from 'styled-components'

export const InfoText = styled.i`
  font-size: 14px;
  margin: 0 0 10px 0;
  display: block;
`
